import './index.scss';

import 'simplebar';
import 'simplebar/dist/simplebar.css';

import './js/navigation';
import './js/smooth-scroll';

jQuery(document).ready(function($) {
    // Menu
    $('.menu-toggle').on('click', function() {
        $('.main-navigation').toggleClass('active');
    });

    // Modal
    var $modalSellingPoints = $('.where-buy-modal');

    $modalSellingPoints.on('click', function(e){
        $modalSellingPoints.addClass('hide');
    });

    $('.where-buy-item, .banner-main-content a').on('click', function(e) {
        e.preventDefault();
        var $this = $(this);

        $modalSellingPoints.removeClass('hide');

        // hide store buttons
        $('.where-buy-point.dentalcremer').attr('href', $this.data('link-dental-cremer'));
        $('.where-buy-point.dentalspeed').attr('href', $this.data('link-dental-speed'));
    });

    // Products
    $('.product-links a').on('click', function(e) {
        e.preventDefault();
        var $this = $(this);
        var $category = $this.parents('.products-category');

        if (window.innerWidth <= 800 && $category.hasClass('rotatorias')) {
            $('.products-content.secondary').show();
            $('.products-content:not(.secondary) .reciprocantes').hide();
        } else {
            $('.products-content.secondary').hide();
            $('.products-content:not(.secondary) .reciprocantes').show();
        }

        $('.product-item:not(.hide)').addClass('hide');
        $('.product-item[data-product-index=' + $this.data('product-index') + ']').removeClass('hide');
        $('.product-item-container:not(:visible)').show(); //.fadeIn('slow');

        if (window.innerWidth <= 800) {
            $('html, body').animate({
                scrollTop: $('.product-item-container').offset().top
            }, 300);
        }
    });

    $('.products-category-thumb').on('click', function(e) {
        e.preventDefault();
        $(this).parent().find('.product-links a:first').trigger('click');
    });
});